import React, { useState } from 'react'
import styled from 'styled-components'
import { useMutation } from '@apollo/client'
import Summary from '../summary'
import { existingCustomerInitialValues, existingCustomerSchema } from '../validationSchemas'
import { SAVE_NEW_CUSTOMER } from 'setup/providerGQL'
import NewCustomerForm from './newCustomerForm'
import { Alarm } from '@mui/icons-material'
import { Alert } from 'bootstrap'
import { ShowErrorAlert } from 'styles/alerts'

const Back = styled.div`
    color: blue;
    cursor: pointer;
`

const FlexBetween = styled.div`
    display: flex;
    justify-content: space-between;
    width: 425px;
`

const H4 = styled.h4`
  text-align: center;
  font-size: 16px;
`

const Space = styled.div`
    width: 45px;
`

const DivCenter = styled.div`
    display: flex;
    justify-content: center;
`

export default function ExistingCustomer(props) {
    const { setSignupType } = props;
    const [error, setError] = useState(null);

    const [saved, setSaved] = useState(false)
    const [saveNewCustomer] = useMutation(SAVE_NEW_CUSTOMER,
        {
            onCompleted() {
                setSaved(true)
            },
            onError: (err) => {
                console.log(err);
                setError(err.graphQLErrors[0].message);
            }
        }
    )

    const map = (values) => {
        return {
            variables: {
                reg: {
                    firstName: values.firstName,
                    lastName: values.lastName,
                    password: values.password,
                    customerIdP21: parseInt(values.customerId),
                    email: values.email,
                    fax: values.fax,
                    jobTitle: values.jobTitle,
                    phone: values.phone,
                    phoneExtension: values.phoneExtension
                }
            }
        }
    }

    const onSubmit = (values, { setSubmitting }) => {
        saveNewCustomer(map(values))
        setSubmitting(false)
    }

    if (saved === true) {
        return <Summary />
    } else {
        return (
            <>
                <FlexBetween>
                    <Back onClick={() => setSignupType('')}>
                        {'< Back'}
                    </Back>
                    <H4>Existing Customer</H4>
                    <Space />
                </FlexBetween>
                {error &&  <DivCenter><ShowErrorAlert message={error} /></DivCenter>}
                <NewCustomerForm
                    useExpandedMode={false}
                    showCustomerLookup={false}
                    newCustomerInitialValues={existingCustomerInitialValues}
                    validationSchema={existingCustomerSchema}
                    onSubmit={onSubmit}
                    choosePasswordEnabled={true}
                    buttonText="Register Account"
                />
            </>
        )
    }
}

